

export default () => {
    $(document).on('click', '.back-top', function () {
        $('html, body').animate({ scrollTop: 0 }, 1000);
    });
}
  
